<template>
  <div v-if="object.documentUrl">
    <a v-for="(doc, docInd) in object.documentUrl"
       class="d-block"
       :key="`doc-${docInd}`"
       :href="doc"
       target="_blank">
      ссылка{{ object.documentUrl.length > 1 ? ` #${docInd + 1}` : '' }}
    </a>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  },
})
</script>
